import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';
import moment from 'moment';
import CreateEvent from '@src/createEvent';

export const quotingStart = () => {
  return {
    type: actionTypes.QUOTING_START
  };
};
export const quotingSuccess = payload => {
  return {
    type: actionTypes.QUOTING_SUCCESS,
    payload: payload
  };
};

export const quotingFail = error => {
  return {
    type: actionTypes.QUOTING_FAIL,
    error: error
  };
};

export const quotingReset = () => {
  localStorage.removeItem('flightInfo');
  localStorage.removeItem('passengers');
  localStorage.removeItem('selectedAircraft');
  return {
    type: actionTypes.QUOTING_RESET
  };
};

export const quotingReload = () => {
  return dispatch => {
    const flightInfo = localStorage.getItem('flightInfo');
    if (flightInfo) {
      dispatch(quotingSuccess(JSON.parse(flightInfo)));
    }
    const aircraft = localStorage.getItem('selectedAircraft');
    if (aircraft) {
      dispatch(quotingSetAircraft(aircraft));
    }

    const passengers = localStorage.getItem('passengers');
    if (passengers) {
      dispatch(quotingSetPassengers(JSON.parse(passengers)));
    }

    const bookerInfo = localStorage.getItem('bookerInfo');
    if (bookerInfo) {
      const bookerInfoObject = JSON.parse(bookerInfo);
      dispatch(
        quotingSetBookerInfo(
          bookerInfoObject.accountName,
          bookerInfoObject.contactEmail
        )
      );
    }
  };
};

export const quotingSetBookerInfo = (accountName, contactEmail) => {
  localStorage.setItem(
    'bookerInfo',
    JSON.stringify({ accountName: accountName, contactEmail: contactEmail })
  );
  return {
    type: actionTypes.QUOTING_SET_BOOKER_INFO,
    payload: { accountName: accountName, contactEmail: contactEmail }
  };
};

export const quotingSetAircraft = aircraft => {
  localStorage.setItem('selectedAircraft', aircraft);
  return {
    type: actionTypes.QUOTING_SET_AIRCRAFT,
    aircraft: aircraft
  };
};
export const quotingSetPassengers = passengers => {
  localStorage.setItem('passengers', JSON.stringify(passengers));
  return {
    type: actionTypes.QUOTING_SET_PASSENGERS,
    passengers: passengers
  };
};

export const quotingSetSpecifications = data => {
  const currentData = JSON.parse(localStorage.getItem('flightInfo'));
  localStorage.setItem(
    'flightInfo',
    JSON.stringify({ pricing: currentData.pricing, legInfo: data })
  );

  return {
    type: actionTypes.QUOTING_SET_SPECIFICATIONS,
    legInfo: data
  };
};

export const quotingGetPrice = (contractId, contractTypeId, legInfo) => {
  return dispatch => {
    dispatch(quotingStart());

    const flightData = legInfo.map(item => {
      let date = moment(item.date).format('MM-DD-YYYY');
      return {
        departure_airport: item.fromCode,
        arrival_airport: item.toCode,
        datetime: date + 'T' + item.time
      };
    });

    const postData = {
      contract_id: contractId,
      contract_type_id: contractTypeId,
      flight_data: flightData
    };

    axiosInstance()
      .post('/quotings/get-price.json', postData)
      .then(response => {
        localStorage.setItem(
          'flightInfo',
          JSON.stringify({ pricing: response.data.result, legInfo: legInfo })
        );
        dispatch(
          quotingSuccess({ pricing: response.data.result, legInfo: legInfo })
        );

        const event = new CustomEvent('quoting_continue', {
          detail: {
            panel: 'pricing'
          }
        });
        setTimeout(() => {
          window.dispatchEvent(event);
        }, 100);
      })
      .catch(err => {
        dispatch(quotingFail(err.response.data.message));
      });
  };
};

// Submit Quote
export const quotingSubmitStart = () => {
  return {
    type: actionTypes.QUOTING_SUBMIT_START
  };
};
export const quotingSubmitSuccess = () => {
  return dispatch => {
    dispatch(quotingReset());
    return {
      type: actionTypes.QUOTING_SUBMIT_SUCCESS
    };
  };
};
export const quotingSubmitFail = error => {
  return {
    type: actionTypes.QUOTING_SUBMIT_FAIL,
    error: error
  };
};
export const quotingSubmit = postData => {
  return dispatch => {
    dispatch(quotingSubmitStart());
    axiosInstance()
      .post('/quotings/submit.json', postData)
      .then(response => {
        if (response.data.status === 1) {
          dispatch(quotingSubmitSuccess());
          const event = new CreateEvent('quote-submitted');
          window.dispatchEvent(event);
        } else {
          dispatch(quotingSubmitFail(response.data.error));
        }
      })
      .catch(err => {
        dispatch(quotingSubmitFail(err.response.data.message));
      });
    //
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/quoting.js